export default "__VITE_ASSET__B7jL71wy__"